import { KYMW1404Model } from '../kymw1404.model';
import { SellingAreaListModel } from '../../kymw1400/vo/selling-area-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 売り場を取得する。
 *
 * @export
 * @class GetSellingAreaService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetSellingAreaService extends PlessJsonResponderSub<any> {

  private model: KYMW1404Model = null;
  private vo: SellingAreaListModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSellingAreaService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        FormID: this.vo.formID,
        MediumType: this.vo.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1404Model} model
   * @param {SellingAreaListModel} vo
   * @memberof GetSellingAreaService
   */
  execute(model: KYMW1404Model, vo: SellingAreaListModel) {
    this.model = model;
    this.vo = vo;
    this.send('getSellingAreaList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSellingAreaService
   */
  success(data: any) {
    // 結果データの編集
    this.model.setSellingAreaList(data);
  }
}
